import React from 'react';

import { Link } from 'react-router-dom';

const PreviousCards = (props) => {

    const { member } = props;

    // Only show previous cards if we are, in fact, looking at the active card
    if (!member.isActiveRecord) {
        return null;
    }

    // Build list of links
    const previousCards = member.history ?
        member.history.map((history) => <Link key={history.slug} to={{pathname: '/members/' + history.slug}}>{history.rewardsCardNumber}<br/></Link>) : [];

    if (previousCards.length === 0) {
        return null;
    }

    return (
        <p className="list--info__label">
            <strong className="text--caps text--color">Previous
                Card(s)</strong>
            {previousCards.length === 0 && <span>-</span>}
            {previousCards.length > 0 && previousCards}
        </p>
    );
};

export default PreviousCards;
